import React, { useCallback } from "react";
import VersionHistoryDialog from "../version-history-dialog";
import {
  fetchOfferCalculationVersions,
  restoreOfferCalculationVersion,
} from "../../../../api/offer-calculation";

/**
 * «Malversjoner» — calculation-template version history + restore.
 * `calculationId` is always the template's own id (offer_id null); when
 * opened from an offer-specific copy, pass its `original_calculation_id`.
 */
export default function CalculationVersionHistoryDialog({
  open,
  onClose,
  calculationId,
  titleKey = "offers.calculation.versions.title",
  onRestored,
}) {
  const fetchVersions = useCallback(
    (id) => fetchOfferCalculationVersions(id),
    []
  );
  const restoreVersion = useCallback(
    (id, versionId) => restoreOfferCalculationVersion(id, versionId),
    []
  );

  return (
    <VersionHistoryDialog
      open={open}
      onClose={onClose}
      title={titleKey}
      entityId={calculationId}
      fetchVersions={fetchVersions}
      restoreVersion={restoreVersion}
      onRestored={onRestored}
    />
  );
}
